import React, { useEffect, useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import Cookies from 'js-cookie';
import { Onboarding } from '@navent-re/onboarding';
import ZPAR from '@panel/commons/assets/logos/zonaprop.svg';
import I2MX from '@panel/commons/assets/logos/inmuebles24.svg';
import DVPE from '@panel/commons/assets/logos/adondevivir.svg';
import UBPE from '@panel/commons/assets/logos/urbania.svg';
import LLVE from '@panel/commons/assets/logos/conlallave.svg';
import PLEC from '@panel/commons/assets/logos/plusvalia.svg';
import CAPA from '@panel/commons/assets/logos/compreoalquile.svg';
import IWBR from '@panel/commons/assets/logos/imovelweb.svg';
import WIBR from '@panel/commons/assets/logos/wimoveis.svg';
import CMBR from '@panel/commons/assets/logos/casa-mineira.svg';
import VAMX from '@panel/commons/assets/logos/vivanuncios.svg';
import QA from '@panel/commons/assets/logos/quinto-andar.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { theme } from '@navent-re/global-styled';
import { ModalBase, Modal } from '@panel/commons';
import { userInfoSelectors } from '../state/ducks/user';
import { facebookIds, googleIds } from '../constants/socialLoginKeys';

const OnboardingWrapper = styled.div`
  div {
    white-space: initial;
  }

  #googleDiv {
    * {
      box-sizing: content-box;
    }
  }
`;

const sites = {
  ZPAR: 'ZP',
  IWBR: 'IW',
  WIBR: 'WI',
  ICBR: 'IW',
  CMBR: 'CMBR',
  '24MX': '24MX',
  VAMX: 'VAMX',
  UBPE: 'URB',
  DVPE: 'ADV',
  PLEC: 'PLV',
  CAPA: 'COA',
  LLVE: 'CLL'
};

const source = {
  ZPAR,
  DVPE,
  UBPE,
  LLVE,
  PLEC,
  CAPA,
  IWBR,
  WIBR,
  '24MX': I2MX,
  CMBR,
  VAMX,
  QA
};

const useLogin = () => {
  const site = process.env.REACT_APP_BUILD_SITE;
  const [login, setLogin] = useState(false);
  const { showLogin } = useSelector(userInfoSelectors.getuserInfoState);
  const { t } = useTranslation();

  const siteInfo = {
    url: window.location.href,
    name: 'name',
    id: sites[site],
    terms: {
      label: 'wording',
      url: 'url'
    }
  };

  const onboardingTranslations = {
    goBack: t('onboarding.goBack'),
    enterEmail: t('onboarding.email.placeholder'),
    enterWith: t('onboarding.signWith'),
    titleOnboarding: t('onboarding.titleOnboarding'),
    titleDescription: t('onboarding.titleDescription'),
    orOnboarding: t('onboarding.or'),
    registerBox: {
      text: t('onboarding.registerBox'),
      cta: t('onboarding.registerHere'),
      ctaProfesional: t('onboarding.ctaProfesional'),
      ctaParticular: t('onboarding.ctaParticular')
    },
    passwordRecovery: {
      title: t('onboarding.recovery.title'),
      subtitle: t('onboarding.recovery.description'),
      successTitle: t('onboarding.recovery.sentYouAnEmail'),
      noMail: t('onboarding.recovery.didntReceiveEmail')
    },
    oldUser: {
      title: t('onboarding.welcome.welcomeBack'),
      subtitle: t('onboarding.welcome.enterPass'),
      forgotPass: t('onboarding.login.forgotPassword')
    },
    newUser: {
      title: t('onboarding.welcome.welcome'),
      subtitle: t('onboarding.welcome.createPass')
    },
    registerOwner: {
      title: t('onboarding.owner.enterData'),
      personalData: t('onboarding.registerOwners.personalInfo'),
      data: t('onboarding.registerOwners.data')
    },
    useInformation: {
      text: 'Autorizo el uso de mi información para ',
      linkText: 'fines adicionales'
    },
    terms: {
      text: t('onboarding.owner.terms'),
      linkText: t('onboarding.owner.termsLink')
    },
    forms: {
      email: {
        label: t('onboarding.email.label'),
        invalidEmail: t('inquiryForm.email.invalid'),
        emptyEmail: t('inquiryForm.email.error')
      },
      password: {
        label: t('onboarding.password.label'),
        assistive: t('onboarding.password.placeholder')
      },
      name: {
        label: t('onboarding.registerOwners.nameLabel')
      },
      lastname: {
        label: t('onboarding.registerOwners.surnameLabel')
      },
      dni: {
        label: t('onboarding.registerOwners.idLabel')
      },
      cuit: {
        label: t('onboarding.registerOwners.cuitLabel')
      },
      phone: {
        label: t('onboarding.registerOwners.phoneLabel')
      },
      cellPhone: {
        label: t('onboarding.registerOwners.mobilePhoneLabel')
      },
      bussinesName: {
        label: sites[site] === 'WI' || sites[site] === 'IW' || sites[site] === 'CMBR' ? 'Razão Social' : 'Razón social'
      },
      license: {
        label: t('onboarding.registerOwners.licenseLabel')
      },
      userType: {
        title: t('onboarding.registerOwners.userType'),
        label: t('onboarding.select'),
        options: {
          particular: t('panel.header.title.particular'),
          realEstate: t('panel.header.title.realestate'),
          constructor: t('panel.header.title.builder'),
          broker: t('panel.header.title.broker')
        }
      },
      fiscalCondition: {
        title: 'Condicion fiscal',
        label: t('onboarding.select')
      },
      continue: t('onboarding.continue'),
      register: t('onboarding.signUp'),
      enter: t('onboarding.register.login'),
      send: t('inquiryForm.button.label'),
      ready: t('onboarding.ready')
    },
    quickLogin: {
      welcome: t('quickLogin.welcome'),
      loginWithEmail: t('quickLogin.loginWithEmail'),
      or: t('quickLogin.or')
    }
  };

  const HandleSetLogin = () => {
    setLogin(true);
  };

  const HandleResponse = ({ status, response, link }) => {
    if (status === 'success') {
      if (response && response.contenido && response.contenido.sessionID) {
        Cookies.remove('sessionId');
        Cookies.set('sessionId', response.contenido.sessionID);
      }
      if (link) {
        window.location.href = link;
      }
      if (!link) {
        window.location.reload();
      }
    }
  };

  const HandleBack = () => {
    window.location.href = window.location.origin;
  };

  useEffect(() => {
    if (showLogin !== login) {
      setLogin(showLogin);
    }
  }, [showLogin, login]);

  const LoginForm = () => {
    return (
      <Modal>
        <ModalBase openModal withoutCloseButton>
          <ThemeProvider theme={theme}>
            <OnboardingWrapper>
              <Onboarding
                logo={source[site]}
                initOn='home'
                siteData={siteInfo}
                translations={onboardingTranslations}
                facebookId={facebookIds[site]}
                googleId={googleIds[site]}
                // appleSignIn={window.appleId}
                fullScreen
                hideModalClose
                onResponse={e => HandleResponse(e)}
                linkToRedir={window.location.href}
                goBack={() => HandleBack()}
              />
            </OnboardingWrapper>
          </ThemeProvider>
        </ModalBase>
      </Modal>
    );
  };

  return { LoginForm, login, setLogin, HandleSetLogin };
};

export { useLogin };
